import { useGT } from 'gt-react';
import {
  isExtensionTargetModel,
  type ExtensionTargetModel,
} from '@erp/shared-types';

/**
 * Labels extendable entities for display. Keyed by the shared target list, so
 * adding a target without a label fails to compile. An unknown saved target
 * keeps its identifier rather than a wrong label.
 */
export function useTargetModelLabel(): (targetModel: string) => string {
  const gt = useGT();
  const labels: Record<ExtensionTargetModel, string> = {
    IM_PRODUCT_V3: gt('Products', {
      context: 'entity a schema extension extends',
    }),
    AP_INVOICE: gt('AP invoices', {
      context: 'entity a schema extension extends',
    }),
    IM_INVENTORY_POLICY: gt('Inventory policies', {
      context: 'entity a schema extension extends',
    }),
  };
  return (targetModel) =>
    isExtensionTargetModel(targetModel) ? labels[targetModel] : targetModel;
}
